export const DEFAULT_POINT_COUNT = 2000;
export const DEFAULT_FILTERED_POINT_COUNT = 5000;
export const DEFAULT_PAGINATED_PAGE_SIZE = 500;
export const CREDIT_TEXT = 'Ascend Analytics';
export const CREDIT_HREF = 'https://www.ascendanalytics.com/solutions/powersimm-suite';
